import { message } from "antd";

export const printPdfFromUrl = async (url: string): Promise<void> => {
  let iframe: HTMLIFrameElement | null = null;
  let blobUrl: string | null = null;

  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000); // 20s timeout

    const res = await fetch(url, { signal: controller.signal });
    clearTimeout(timeout);

    if (!res.ok) {
      throw new Error(`Failed to fetch PDF (${res.status})`);
    }

    const blob = await res.blob();

    if (blob.type !== "application/pdf") {
      console.warn("Fetched file is not a PDF:", blob.type);
    }

    blobUrl = URL.createObjectURL(blob);

    iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.src = blobUrl;

    iframe.onload = () => {
      try {
        iframe?.contentWindow?.focus();
        iframe?.contentWindow?.print();
      } catch (err) {
        console.error("Print failed:", err);
      } finally {
        setTimeout(() => {
          if (blobUrl) URL.revokeObjectURL(blobUrl);
          if (iframe) document.body.removeChild(iframe);
        }, 1500);
      }
    };

    document.body.appendChild(iframe);
  } catch (err) {
    console.error("printPdfFromUrl error:", err);

    if (blobUrl) URL.revokeObjectURL(blobUrl);
    if (iframe) document.body.removeChild(iframe);

    message.error("Unable to print the document. Please try again.");
  }
};
